<template>
  <div class="text-left">
    <v-card>
      <v-form class="pa-6" ref="form">
        <v-row>
          <v-col cols="12">
            <h3 class="text-left">{{ $t("title.organizationData") }}</h3>
          </v-col>
        </v-row>

        <h5>
          {{ $t("form.name") }}
        </h5>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-text-field
              v-model="organization.name"
              :label="$t('form.name')"
              required
              outlined
              :rules="rules.char_required_max_200"
              :counter="200"
            ></v-text-field>
          </v-col>
        </v-row>
        <h5>
          Web
        </h5>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-text-field
              v-model="organization.web"
              label="Web"
              outlined
              :rules="rules.char_max_300"
              :counter="300"
            ></v-text-field>
          </v-col>
        </v-row>

        <h5>
          {{ $t("form.organization.logo") }}
        </h5>
        <UploadImage
          :path="
            this.$store.state.endpoint + '/organization/' + this.organization.id
          "
          :url="this.$store.state.endpoint + this.organization.logo"
          :object="{ name: organization.logo }"
          :object_created="this.organization.id !== undefined"
          name_field="logo"
        />
        <v-divider />
        <div class="text-center">
          <v-btn text @click="$router.back()"><v-icon left>mdi-arrow-left</v-icon>{{ $t("button.back") }}</v-btn>
          <v-btn color="primary" @click="save" class="ml-2"><v-icon left>mdi-content-save</v-icon>{{ $t("button.save") }}</v-btn>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
import UploadImage from "../../components/layouts/UploadImage";

export default {
  components: { UploadImage },
  mixins: [validationRules],
  name: "EditOrganizationDetail",
  data: () => ({
    organization: {
      name: "",
      web: "",
      logo: null
    }
  }),

  created() {
    if (this.$route.params.id > -1) {
      this.getOrganization();
    }
  },

  computed: {
    processData() {
      let data = {
        name: this.organization.name,
        web: this.organization.web
      };
      return data;
    }
  },

  methods: {
    getOrganization() {
      let path =
        this.$store.state.endpoint + "/organization/" + this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.organization = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    save() {
      if (this.$refs.form.validate()) {
        let path;
        if (this.$route.params.id > -1) {
          path =
            this.$store.state.endpoint +
            "/organization/" +
            this.$route.params.id;
          axios
            .patch(path, this.processData)
            .then(() => {
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.updateItem")
              });
              this.$router.push("/manage/edit/organizations");
            })
            .catch(error => {
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          path = this.$store.state.endpoint + "/organization";
          axios
            .post(path, this.processData)
            .then(response => {
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.createItem")
              });
              this.$router.push("/manage/edit/organizations");
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
      }
    }
  }
};
</script>
